import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { Constants } from '../../constants/constants';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { FileItem, FileUploader } from 'ng2-file-upload';



@Component({
  selector: 'modal-file-upload',
  templateUrl: './modal-file-upload.component.html',
  styleUrls: ['./modal-file-upload.component.scss'],
})
export class ModalFileUploadComponent implements OnInit {

  public uploader: FileUploader = null;
  uploadUrl = null;
  uploadData = null;
  clickRequired = false;

  constructor(private router: Router, public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    this.initFileUploader();
  }


  initFileUploader() 
  {
    if (!this.uploadData)
    {
      this.uploadData = {};
    }

    var baseUrl = Constants.PROD_URL + this.uploadUrl;

    this.uploader = new FileUploader({
      url: baseUrl,
      headers: [{ name: 'Accept', value: 'application/json' }, { name: 'id', value: this.userService.getSessionId() }],
      additionalParameter: this.uploadData
    });

    // Fix for CORS
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };

    this.uploader.onCompleteAll = () => {

      this.appearanceService.dismissLoading();
      this.appearanceService.presentToast("Upload Succesful.", Constants.TOAST_SUCCESS);
      this.modalController.dismiss({ reload: true }, null, 'FileUploadModal');
    };

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => { };

    this.uploader.onSuccessItem = (item: any, response: string, status: number, headers: any): any => { }

    this.uploader.onErrorItem = (item: any, response: string, status: number, headers: any): any => { }
  }


  uploaderAddOptions(data)
  {
    if (!data)
    {
      data = {};
    }

    this.uploader.setOptions({additionalParameter:data});
  }


  uploadAll()
  {
    this.appearanceService.showLoading("Uploading...").then(() => {

      if (this.uploader.queue.length > 0) 
      {
        this.uploader.uploadAll();
      }
      else
      {
        this.appearanceService.dismissLoading();
      }
    });
  }


  ionViewWillLeave()
  {

  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'FileUploadModal');
  }
}
